export default __webpack_public_path__ + "static/media/markit-card.7cc3f192.webp";